import { fcom, sodimac, tottus } from '@digital-retail/design-system-themes';

export const getTheme = (store) => {
  switch (store) {
    case 'to_com':
      return tottus;
    case 'so_com':
      return sodimac;
    default:
      return fcom;
  }
};
